// extracted by mini-css-extract-plugin
export default {"root":"_2ywFv","content":"_2KLFv","text":"_2eYBg","buttons":"_2a1Dq","button":"_1OA4Q","link":"ilEvv","emphasis":"_2hYt4"};